import { Autocomplete, TextField } from "@mui/material";
import React from "react";

const TableSelector = ({ tables, selectedTable, onSelectTable }) => {
  const _selectedTable = tables.find((item) => item.name === selectedTable);
  const filterOptions = (options, { inputValue }) => {
    return options.filter(
      (option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.name.toLowerCase().includes(inputValue.toLowerCase())
    );
  };
  return (
    <div className="mb-4">
      <label className="form-label fw-bold">Step 1: Select Base Table</label>
      <Autocomplete
        disablePortal
        className="form-select"
        size="small"
        options={tables}
        value={_selectedTable || null}
        onChange={(e, newValue) =>
          newValue?.name && onSelectTable(newValue?.name)
        }
        isOptionEqualToValue={(option, value) => option.name === value.name}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField {...params} label="-- Choose a table --" />
        )}
        renderOption={(props, option) => (
          <li key={option?.name} {...props}>
            {option.label}
          </li>
        )}
        filterOptions={filterOptions}
      />
    </div>
  );
};

export default TableSelector;
